import React, { useState } from "react";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { QUERY_CAR_CONTRACTS } from "../../../service/ApolloClient/ApolloQueries";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import { Box, Button, IconButton } from "@material-ui/core";
import AutoCompleteMU from "../../UI/AutoCompleteMU/AutoCompleteMU";
import { Link } from "react-router-dom";
import { RemoveRedEye } from "@material-ui/icons";

const ChequeAddFormChequeableCar = (props) => {
  const { title, setFieldValue, value, fieldName, fieldNameShow } = props;
  const [keyword, setKeyword] = useState(props.value);
  const [modalOpen, setModalOpen] = useState(false);
  const query = client
    .query({
      query: QUERY_CAR_CONTRACTS,
      variables: {
        search: keyword,
        limit: 20,
        page: 1,
      },
      fetchPolicy: "network-only",
    })
    .catch((err) => console.log(err));

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <Wrapper>
      <Box display={"flex"} p={1}>
        <Box flexGrow={1}>
          <AutoCompleteMU
            fieldNameShow={"chequeable_name"}
            value={value ? value : ""}
            title={"انتخاب معامله ماشین"}
            setFieldValue={setFieldValue}
            keyword={keyword}
            setKeyword={setKeyword}
            query={query}
            queryName={"carContracts"}
            field={["id", "seller_fullname", "buyer_fullname"]}
            fieldSelect={"id"}
            fieldName={"chequeable_id"}
          />
        </Box>
        <Box>
          <Button>
            <Link
              to={`/car-contract/edit/${props.values.chequeable_id}`}
              target={"_blank"}
            >
              <IconButton>
                <RemoveRedEye />
              </IconButton>
            </Link>
          </Button>
        </Box>
      </Box>
    </Wrapper>
  );
};

export default React.memo(ChequeAddFormChequeableCar);
